import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import icon from "../../picture/AMETHYST-LOGO-removebg-preview.png";
import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../services/auth.serviceV2";
import { Modal, Button } from "react-bootstrap";
import cancel from "../../picture/cancel.png";
import Static_modal from "../user/etc/Static_modal";
const required = (value) => {
  if (!value) {
    return (
      <div className="invalid-feedback d-block">This field is required!</div>
    );
  }
};

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();
  const [loginfail, setLoginfail] = useState(false);
  const [servererror, setServererror] = useState(false);
  const [errordata, setErrordata] = useState("");
  // const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [sentrepassword, setSentrepassword] = useState(false);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const [showrepass, setShowrepass] = useState(false);
  const navigate = useNavigate();
  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };
  const loginfailed = () => {
    setLoginfail(true);
    setLoading(false);
  };
  const handlerepassword = () => {
    setShowrepass(true);
  };
  const handlesentrepassword = () => {
    setSentrepassword(true);
    AuthServiceV2.resetpassword(email)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setLoading(false);
        setMessage(resMessage);
      });
  };
  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();
    //console.log(email,password)
    if (checkBtn.current.context._errors.length === 0) {
      AuthServiceV2.login(email, password)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            navigate("/home");
            window.location.reload();
            // setUserId(response.user_id);
            // setToken(response.jwt);
            // console.log(response.user_id);
            // setLogin(true);
          } else {
            if (response === "Invalid user credentials") {
              loginfailed();
            } else {
              if (response === "Your email not verify") {
                setServererror(true);
              }
              loginfailed();
              // setErrordata(response);
              // setServererror(true);
            }
          }

          //AuthService.getCurrentUser(response.userid,response.jwt,login)
        })
        .catch((error) => {
          console.log(error);
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
          if (error === "Invalid user credentials") {
            loginfailed();
          } else {
            if (error === "Your email not verify") {
              setServererror(true);
            } else {
              loginfailed();
            }
          }
        });
    } else {
      setLoading(false);
    }
  };
  const handleClose = () => {
    setLoginfail(false);
  };
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        background:
          "linear-gradient(45deg, #3e194dff 0%, #5d00c7 100%)",
      }}
    >
      <div className="col-md-12">
        <div className="card card-box-login">
          <img src={icon} alt="profile-img" className="profile-img-card" />
          
          <div className="font-cen" style={{ textAlign: "center", marginTop:"15px" }}>
            <span>Unmanned Aircraft System Traffic Management</span>
          </div>
          {showrepass === false ? (
            <Form onSubmit={handleLogin} ref={form}>
              <div className="form-group">
                <label htmlFor="email">อีเมล</label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={email}
                  onChange={onChangeEmail}
                  validations={[required]}
                  style={{
                    background: "#FFFFFF",
                    border: "1px solid rgba(0, 0, 0, 0.5)",
                    boxShadow: " 0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                    borderRadius: "10px",
                    height: "55px",
                  }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">รหัสผ่าน</label>
                <Input
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={onChangePassword}
                  validations={[required]}
                  style={{
                    background: "#FFFFFF",
                    border: "1px solid rgba(0, 0, 0, 0.5)",
                    boxShadow: " 0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                    borderRadius: "10px",
                    height: "55px",
                  }}
                />
              </div>

              <label
                className="forgot-password"
                onClick={() => handlerepassword()}
              >
                <p>ลืมรหัสผ่านหรือไม่ ?</p>
              </label>

              <div className="form-group">
                <button
                  //className="btn btn-primary btn-block"
                  disabled={loading}
                  className="custom-btn btnSave"
                  style={{
                    width: "100%",
                    height: "60px",
                    fontSize: "26px",
                  }}
                >
                  <span>เข้าสู่ระบบ</span> &nbsp;
                  {loading && (
                    <span className="spinner-border spinner-border"></span>
                  )}
                </button>
                <div
                  style={{
                    display: "flex",
                    position: "absolute",
                    width: "100%",
                    left: "24%",
                    bottom: "0",
                    textAlign: "center",
                  }}
                >
                  <p>
                    ยังไม่มีบัญชีหรือไม่ ?{" "}
                    <Link to={"/register"}>ลงทะเบียน</Link>
                  </p>
                </div>
              </div>

              {/* {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert" style={{}}>
                  {message}
                </div>
              </div>
            )} */}

              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          ) : sentrepassword === false ? (
            <div>
              กรุณากรอกอีเมลล์
              <div>
                <input
                  style={{
                    border: "solid 1px",
                    borderRadius: "10px",
                    width: "100%",
                    height: "50px",
                  }}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <br />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  className="custom-btn btnSave"
                  style={{
                    width: "40%",
                    height: "50px",
                    fontSize: "18px",
                  }}
                  onClick={() => handlesentrepassword()}
                >
                  ยืนยัน
                </button>
                &nbsp;
                <button
                  className="custom-btn btnCancel"
                  style={{
                    width: "40%",
                    height: "50px",
                    fontSize: "18px",
                  }}
                  onClick={() => setShowrepass(false)}
                >
                  ย้อนกลับ
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{
                  width: "100%",
                  height: "50px",
                  fontSize: "18px",
                  border: "solid 2px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ส่งอีเมลยืนยันเรียบร้อย กรุณาเช็คในอีเมลของท่าน
              </div>
              <br />
              <button
                className="custom-btn btnCancel"
                style={{
                  width: "40%",
                  height: "50px",
                  fontSize: "18px",
                }}
                onClick={() => {
                  setShowrepass(false);
                  setSentrepassword(false);
                }}
              >
                ย้อนกลับ
              </button>
            </div>
          )}

          <Modal
            show={loginfail}
            centered
            onHide={handleClose}
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
            className="font-cen"
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "30px",
                borderRadius: "40px",
                //background: "black",
              }}
            >
              <img alt="" src={cancel} style={{ width: "40px" }} />
              <br />

              <h2>Wrong username or password</h2>
              <Button
                variant="secondary"
                onClick={() => {
                  setLoginfail(false);
                  setLoading(false);
                }}
              >
                Close
              </Button>
            </Modal.Body>
          </Modal>
          <Modal
            show={servererror}
            centered
            onHide={() => setServererror(false)}
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
            className="font-cen"
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "30px",
                borderRadius: "40px",
                //background: "black",
              }}
            >
              <img alt="" src={cancel} style={{ width: "40px" }} />
              <br />
              <h2>กรุณายืนยันอีเมล</h2>
              {/* <h2>{errordata}</h2> */}
              <Button
                variant="secondary"
                onClick={() => {
                  setServererror(false);
                  setLoading(false);
                }}
              >
                Close
              </Button>
            </Modal.Body>
          </Modal>
          {/* <div
            style={{
              display: "flex",
              position: "absolute",
              width: "100%",
              left: "24%",
              bottom:"0",
              textAlign: "center",
            }}
          >
            <p>
            ยังไม่มีบัญชีหรือไม่ ? <Link to={"/register"}>ลงทะเบียน</Link>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
